<template>
  <div :class="$style['signup']">
    <header :class="[$style['header']]">
      <img
        v-if="$route.params.site === 'v4b'"
        src="@/assets/images/v4b_header.png"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'v4b'"
        src="@/assets/images/v4b_header_mobile.jpg"
        class="w-full block md:hidden"
      >

      <img
        v-if="$route.params.site === 'golf8jarama'"
        src="@/assets/images/signup_header.jpg"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'golf8jarama'"
        src="@/assets/images/signup_header_mobile.jpg"
        class="w-full block md:hidden"
      >

      <img
        v-if="$route.params.site === 'id-experience-barcelona' || $route.params.site === 'id-experience-madrid'"
        src="@/assets/images/experience_header.jpg"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'id-experience-barcelona' || $route.params.site === 'id-experience-madrid'"
        src="@/assets/images/experience_header_mobile.jpg"
        class="w-full block md:hidden"
      >
    </header>

    <section
      :class="$style['content']"
      class="mt-10"
    >
      <h3 class="text-2xl md:text-xxl font-light">
        {{ pageTitle }}
      </h3>
    </section>

    <section
      :class="$style['content']"
      class="mt-5"
    >
      <div v-if="initialLoading">
        <VSpinner class="text-xxl text-primary-dark-blue" />
      </div>

      <div v-else-if="initialError">
        Ops, ha habido un error al intentar optener los datos del servidor.

        <a
          class="link"
          @click="reload"
        >
          Recargar
        </a>
      </div>

      <form
        v-else
        @submit.prevent="onSubmit"
      >
        <h2 class="text-xl leading-xl font-light mt-5 md:mt-20 mb-10">
          Datos de contacto
        </h2>

        <v-grid class="font-light">
          <v-grid-column
            col="full"
            col-md="1/4"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.title.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Trato *
              </div>
              <v-select
                :options="{ mr: 'Señor', ms: 'Señora' }"
                :value="$v.fields.title.$model"
                @change="value => $v.fields.title.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/4"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.firstName.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Nombre *
              </div>
              <v-input
                type="text"
                :value="$v.fields.firstName.$model"
                @change="value => $v.fields.firstName.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/4"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.lastName.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Primer apellido *
              </div>
              <v-input
                :value="$v.fields.lastName.$model"
                @change="value => $v.fields.lastName.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/4"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.secondLastName.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Segundo apellido *
              </div>
              <v-input
                :value="$v.fields.secondLastName.$model"
                @change="value => $v.fields.secondLastName.$model = value"
              />
            </v-field>
          </v-grid-column>
        </v-grid>

        <v-grid>
          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.company.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Empresa *
              </div>
              <v-input
                :value="$v.fields.company.$model"
                @change="value => $v.fields.company.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.dni.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                DNI *
              </div>
              <v-input
                type="text"
                :value="$v.fields.dni.$model"
                @change="value => $v.fields.dni.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.email.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Correo electrónico *
              </div>
              <v-input
                type="email"
                :value="$v.fields.email.$model"
                @change="value => $v.fields.email.$model = value"
              />
            </v-field>
          </v-grid-column>
        </v-grid>

        <v-grid>
          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="phoneValidationMessage"
            >
              <div class="mb-1 whitespace-no-wrap">
                Teléfono *
              </div>
              <v-input
                type="tel"
                :value="$v.fields.phone.$model"
                @change="value => $v.fields.phone.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.postalCode.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Código postal
              </div>
              <v-input
                :value="$v.fields.postalCode.$model"
                @change="value => $v.fields.postalCode.$model = value"
              />
            </v-field>
          </v-grid-column>

          <v-grid-column
            col="full"
            col-md="1/3"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.locality.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                Localidad
              </div>
              <v-input
                :value="$v.fields.locality.$model"
                @change="value => $v.fields.locality.$model = value"
              />
            </v-field>
          </v-grid-column>

          <template v-if="$route.params.site === 'v4b'">
            <v-grid-column
              col="full"
              col-md="1/4"
            >
              <v-field
                class="text-base leading-xs mt-5 mb-2 font-light"
                :error="$v.fields.job.$error ? 'El campo es obligatorio.' : ''"
              >
                <div class="mb-1 whitespace-no-wrap">
                  Cargo *
                </div>
                <v-input
                  :value="$v.fields.job.$model"
                  @change="value => $v.fields.job.$model = value"
                />
              </v-field>
            </v-grid-column>
          </template>
        </v-grid>

        <v-grid v-if="isFormWithCompanion">
          <v-grid-column
            col="full"
          >
            <v-field
              class="text-base leading-xs mt-5 mb-2 font-light"
              :error="$v.fields.companion.$error ? 'El campo es obligatorio.' : ''"
            >
              <div class="mb-1 whitespace-no-wrap">
                ¿Vienes con acompañante? *
              </div>
              <v-field class="text-m leading-xs mt-5 mb-2 font-light">
                <v-radio-group
                  name="companion"
                  :radios="[{label: 'Sí', value: 1}, {label: 'No', value: 0}]"
                  :value="$v.fields.companion.$model"
                  class="text-m leading-m"
                  @change="event => $v.fields.companion.$model = event.value"
                />
              </v-field>
            </v-field>
          </v-grid-column>
        </v-grid>

        <div>
          <h2 class="text-xl leading-xl font-light mt-16 mb-10">
            Elige tu turno: el día <strong>13 de abril</strong> en el concesionario de <strong>Glorieta Santa Maria de la Cabeza</strong> y/o el día <strong>14 de abril</strong> en el concesionario de <strong>Rivas Vaciamadrid</strong>.
          </h2>

          <v-grid>
            <v-grid-column
              col="full"
              col-md="1/4"
            >
              <v-field
                class="text-base font-light leading-xs mt-5 mb-2"
                :error="$v.fields.day.$error ? 'El campo es obligatorio.' : ''"
              >
                <div class="mb-1 whitespace-no-wrap">
                  Día *
                </div>
                <v-select
                  :options="days"
                  :value="$v.fields.day.$model"
                  optional
                  @change="changeDay"
                />
              </v-field>
            </v-grid-column>

            <v-grid-column
              col="full"
              col-md="1/4"
            >
              <v-field
                class="text-base leading-xs mt-5 mb-2 font-light"
                :error="$v.fields.hour.$error ? 'El campo es obligatorio.' : ''"
              >
                <div class="mb-1 whitespace-no-wrap">
                  Hora *
                </div>
                <v-select
                  :options="hours[fields.day]"
                  :value="$v.fields.hour.$model"
                  :placeholder="hourPlaceHolder"
                  optional
                  @change="value => $v.fields.hour.$model = value"
                />
              </v-field>
            </v-grid-column>

            <v-grid-column
              v-if="accessWaitingList"
              col="full"
            >
              <div class="font-bold mt-3">
                El turno seleccionado está completo, accederás a la lista de espera.
              </div>
            </v-grid-column>
          </v-grid>
        </div>

        <h2
          v-if="$route.params.site === 'v4b'"
          class="text-xl leading-xl font-light mt-16 mb-10"
        >
          Mantente al día
        </h2>

        <v-field
          v-if="$route.params.site === 'v4b'"
          class="text-base leading-xs mb-10 font-light"
          :error="$v.fields.checkCommercial.$error ? 'El campo es obligatorio.' : ''"
        >
          <div class="text-m leading-m mb-4">
            ¿Te gustaría recibir descuentos y novedades de Volkswagen? *
          </div>
          <v-radio-group
            name="checkCommercial"
            :radios="[{label: 'Sí', value: 1}, {label: 'No', value: 0}]"
            :value="$v.fields.checkCommercial.$model"
            class="text-m leading-m"
            @change="event => $v.fields.checkCommercial.$model = event.value"
          />
        </v-field>

        <v-field
          v-if="$route.params.site === 'v4b'"
          class="text-base leading-xs mb-2 font-light"
          :error="$v.fields.checkProfile.$error ? 'El campo es obligatorio.' : ''"
        >
          <div class="text-m leading-m mb-4 font-light">
            ¿Podemos mejorar nuestras ofertas y servicios personalizándolos según tu perfil? *
          </div>
          <v-radio-group
            name="checkProfile"
            :radios="[{label: 'Sí', value: 1}, {label: 'No', value: 0}]"
            :value="$v.fields.checkProfile.$model"
            class="text-m leading-m"
            @change="event => $v.fields.checkProfile.$model = event.value"
          />
        </v-field>

        <div
          class="mt-16 mb-8 text-base leading-xs font-light"
          :class="$style['label-color']"
        >
          Al enviar este formulario confirmas haber leído y aceptado nuestra
          <a
            href="https://www.volkswagen.es/es/volkswagen-espana/datos-privacidad.html"
            target="_blank"
            class="link"
          >
            Política de Datos y Privacidad
          </a>
          .
        </div>

        <div class="mb-12 text-center font-light">
          <button
            type="submit"
            class="button"
            :disabled="loading"
          >
            {{ submitText }}
          </button>

          <p
            v-if="validationError"
            class="mt-5 text-danger-50 font-light"
          >
            Comprueba todos los campos del formulario.
          </p>

          <p
            v-if="backError"
            class="mt-5 text-danger-50"
          >
            {{ backError }}
            <a
              v-if="errorWithReload"
              class="link"
              @click="reload"
            >
              {{ errorWithReload }}
            </a>
          </p>

          <div class="text-left font-bold text-base leading-xs mt-10">
            * Plazas limitadas
          </div>
        </div>

        <div
          class="text-base leading-xs font-light"
          :class="$style['label-color']"
        >
          <p>
            Te informamos que el responsable del tratamiento de tus datos es la compañía VOLKSWAGEN GROUP ESPAÑA DISTRIBUCION, S.A.U., con la finalidad de atender tus consultas y solicitudes, realizar un control de calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de mercado con fines estadísticos. En caso que nos hayas dado tu consentimiento, para las finalidades descritas en los consentimientos adicionales.
          </p>
          <br>
          <p>
            Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la portabilidad, mediante petición escrita a
            <a
              href="mailto:atencioncliente@volkswagen.es"
              target="_blank"
              class="link"
            >
              atencioncliente@volkswagen.es
            </a>
            .
          </p>
          <br>
          <p>
            Puedes consultar con mayor detalle la información adicional sobre Protección de datos
            <a
              href="https://www.volkswagen.es/es/volkswagen-espana/datos-privacidad.html"
              target="_blank"
              class="link"
            >aquí
            </a>
            .
          </p>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'

import VSpinner from '@c/base/Spinner'
import VField from '@c/base/Field'
import VInput from '@c/base/Input'
import VRadioGroup from '@c/base/RadioGroup'
import VSelect from '@c/base/Select'
import VGrid from '@c/base/Grid'
import VGridColumn from '@c/base/GridColumn'

export default {
  components: { VSpinner, VField, VInput, VSelect, VGrid, VGridColumn, VRadioGroup },

  data () {
    return {
      loading: false,
      validationError: false,
      backError: null,
      errorWithReload: null,
      disableHour: false,
      fields: {
        title: null,
        firstName: null,
        lastName: null,
        secondLastName: null,
        dni: null,
        email: null,
        phone: null,
        postalCode: null,
        locality: null,
        companion: null,
        job: null,
        company: null,
        day: null,
        hour: null,
        checkCommercial: null,
        checkProfile: null
      },
      days: {},
      hours: {},
      slots: [],
      initialLoading: true,
      initialError: false
    }
  },

  computed: {

    pageTitle () {
      if (this.$route.params.site === 'v4b') {
        return 'Volkswagen ID. Buzz'
      }

      if (this.$route.params.site === 'golf8jarama') {
        return 'Descubre el nuevo Golf 8 en exclusiva'
      }

      if (this.$route.params.site === 'id-experience-barcelona') {
        return 'Disfruta de la conducción con el nuevo ID. en Barcelona'
      }

      if (this.$route.params.site === 'id-experience-madrid') {
        return 'Disfruta de la conducción con el nuevo ID. en Madrid'
      }

      return ''
    },

    phoneValidationMessage () {
      if (this.$v.fields.phone.$error) {
        return !this.$v.fields.phone.phoneVal
          ? 'El teléfono no es válido'
          : 'El campo es obligatorio.'
      }

      return ''
    },

    showSelectTime () {
      return Object.keys(this.days).length > 1 ||
             Object.keys(this.hours).length > 1
    },

    submitText () {
      if (this.loading) {
        return 'Cargando'
      }

      return this.accessWaitingList ? 'Apúntate a la lista de espera' : 'Apúntate'
    },

    hourPlaceHolder () {
      return this.fields.day ? '' : 'Elige primero un día'
    },

    accessWaitingList () {
      return this.fields.hour && this.fields.hour.includes('lista de espera')
    },

    isFormWithCompanion () {
      return false
    }
  },

  created () {
    axios.get('/api/' + this.$route.params.site + '/slots')
      .then(result => {
        this.slots = result.data.data
        let days = _.uniq(this.slots.map(slot => slot.day))

        let mes = 'Abril'
        switch (this.$route.params.site) {
          case 'golf8jarama' :
            mes = 'Abril'
            break
          case 'id-experience-barcelona' :
            mes = 'Noviembre'
            break
          case 'id-experience-madrid' :
            mes = 'Noviembre'
            break
          default:
            mes = 'Abril'
            break
        }

        days.forEach(day => {
          let hours = this.slots
            .filter(slot => slot.day === day)
            .map(slot => slot.available ? slot.time : slot.time + ' (lista de espera)')

          this.$set(this.days, day, day + ' de ' + mes)
          this.$set(this.hours, day, hours)
        })

        if (Object.keys(this.days).length === 1) {
          this.$v.fields.day.$model = Object.keys(this.days)[0]
          this.$v.fields.hour.$model = this.hours[this.fields.day].length === 1
            ? this.hours[this.fields.day][0]
            : null
        }
      })
      .catch(() => {
        this.initialError = true
      })
      .finally(() => {
        this.initialLoading = false
      })
  },

  mounted () {
    this.$emit('update-menu-color', '#001e50')
  },

  methods: {
    onSubmit () {
      if (this.loading) {
        return
      }

      // this.$v.fields.day.$model = Object.keys(this.days).length === 1
      //   ? Object.keys(this.days)[0] + '' : this.$v.fields.day.$model

      // this.$v.fields.hour.$model = Object.keys(this.hours).length === 1
      //   ? this.hours[this.fields.day][0] : this.$v.fields.hour.$model

      this.validationError = false
      this.backError = null
      this.errorWithReload = null
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.validationError = true
      } else {
        this.loading = true

        this.submit()
          .then(() => {
            this.$router.push({
              name: 'success',
              params: {
                waitingList: this.accessWaitingList
              }
            })
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.category === 'tickets_available') {
                this.backError = 'No quedan plazas para el día y hora seleccionados.'
                this.errorWithReload = 'Recargar para ver las fechas disponibles'
              } else {
                this.backError = 'Se ha producido un error al intentar realizar la reseva.'
              }
            } else if (error.request) {
              this.backError = 'Se ha producido un error de conección con el servidor. Intentalo de nuevo más tarde.'
            } else {
              this.backError = 'Se ha producido un error de servidor. Intentalo de nuevo más tarde.'
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    submit () {
      return axios.post('/api/' + this.$route.params.site + '/attendee', {
        data: _.mapKeys(this.fields, (v, k) => _.snakeCase(k))
      })
    },

    reload () {
      this.initialError = false
      this.backError = null

      window.scrollTo(0, 0)
      location.reload()
    },

    changeDay (value) {
      this.$v.fields.day.$model = value
      this.fields.hour = null
    },

    resetForm () {
      for (let field in this.fields) {
        if (this.fields.hasOwnProperty(field)) {
          this.fields[field] = null
        }
      }
    }
  },

  validations () {
    const phoneVal = value => {
      if (typeof value === 'undefined' || value === null || value === '') {
        return true
      }

      return /^[6789][0-9]{8}$/.test(value)
    }

    let validate = {
      fields: {
        title: {
          required
        },
        firstName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        lastName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        secondLastName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        company: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        dni: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        email: {
          required,
          email,
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        phone: {
          required,
          phoneVal
        },
        postalCode: {
          minLength: minLength(4),
          maxLength: maxLength(7)
        },
        locality: {
          minLength: minLength(3),
          maxLength: maxLength(100)
        },
        day: {
          required
        },
        hour: {
          required
        },
        checkCommercial: {
          required
        },
        checkProfile: {
          required
        }
      }
    }

    if (this.$route.params.site === 'v4b') {
      validate.fields = {
        ...validate.fields,
        company: {
          required
        },
        job: {
          required
        }
      }
    } else {
      // validate.fields.companion = {
      //   required
      // }
    }

    return validate
  }
}
</script>

<style
  module
  lang="scss"
>
.signup {
  padding: 150px 0;
}

.content {
  @apply m-auto;

  padding: 0 1.5em;
  max-width: 1080px;
}

@media (min-width: 768px) {
  .content {
    padding: 0 4rem;
  }
}

@media (min-width: 992px) {
  .content {
    padding: 0 6rem;
  }
}

@media (min-width: 1200px) {
  .content {
    padding: 0 8rem;
  }
}
</style>
